module.exports = __webpack_public_path__ + "static/img/introductionLeft.fc06ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introductionLeft.png
// module id = DQWJ
// module chunks = 1